export enum CancellationFlowStrategy {
    Reminder = 'Reminder',
    Discount = 'Discount',
    Pause = 'Pause',
    ChangePlan = 'ChangePlan',
    FreeMonth = 'FreeMonth',
    HelpLogin = 'HelpLogin',
    Return = 'Return',
}
